import React from 'react'

const ProductDescription=()=> {
  return (
    <>
  <div className="product_supplier_inner">
              <h2>Product Details</h2>
              <p className="justify-para">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </p>
            </div>
            <div className="product_supplir_profile">
              <div className="d-flex">
                <div className="profile-list profile-brand">
                  <h2>Profile</h2>
                  <div className="row justify-content-between">
                    <div className="col_left">
                      <ul>
                        <li>
                          <h6>
                            Your Brand Belongs To One Of The Following Category?
                          </h6>
                        </li>
                        <li>
                          <p>Machines & Equipments</p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>
                            If You Are An Equipment Brand, Please Describe Your
                            Technology
                          </h6>
                        </li>
                        <li>
                          <p>Laser, Hair Removal</p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>
                            Describe Your Brand Concept, Philosophy And Identity
                          </h6>
                        </li>
                        <li>
                          <p>
                            Aerolase Corporation (NY USA) Manufacturers
                            Completely Uniqe And Portable Laser Technology For
                            The Treatment Of All Skin Types.
                          </p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>Specify Your Current Sales Channels</h6>
                        </li>
                        <li>
                          <p>
                            Dermatologists, plastic surgeons, aesthetic centers
                            and clinics, medical spa, Laser therapists
                          </p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>
                            What are the countries of interest for distribution?
                          </h6>
                        </li>
                        <li>
                          <p>
                            France, Belgium, Netherlands, Switzerland,
                            Scandinavia, Czechia.
                          </p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>
                            What are the differentiation points of your brand?
                          </h6>
                        </li>
                        <li>
                          <p>
                            Unique Microsecond-pulsed laser treats all skin
                            types. Painless treatment. Over 30 FDA approved
                            indications. manufactured in New York State.
                          </p>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <h6>
                            Why should the distributor carry your products?
                          </h6>
                        </li>
                        <li>
                          <p>
                            Unique technology - no other laser company has this.
                            Treats a very wide range of skin conditions, both
                            cosmetic and medical.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

    </>
  )
}

export default ProductDescription